module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-bag-0da956c902fe725b1875f4e7d08969fa.webp";